import VueRouter from 'vue-router';

const Animals = () => import('../src/domains/animals/Animals'),
  Animal = () => import('../src/domains/animals/Animal'),
  Adoptions = () => import('../src/domains/adoptions/Adoptions'),
  Activity = () => import('../src/domains/activity/Activity'),
  Login = () => import('../src/domains/account/Login'),
  Register = () => import('../src/domains/account/Register'),
  Pending = () => import('../src/domains/account/Pending'),
  Slideshow = () => import('../src/domains/slideshow/Slideshow');

const router = new VueRouter({
  mode: 'history',
  routes: [{
      name: 'root',
      path: '/',
      redirect: '/animals',
    },
    {
      name: 'login',
      path: '/login',
      component: Login,
    },
    {
      name: 'register',
      path: '/register',
      component: Register,
    },
    {
      name: 'pending',
      path: '/pending',
      component: Pending,
    },
    {
      name: 'adoptions',
      path: '/adoptions/:page?',
      props: true,
      component: Adoptions,
    },
    {
      name: 'animals',
      path: '/animals/:page?',
      props: true,
      component: Animals,
    },
    {
      name: 'animal',
      path: '/animal/:animalId',
      props: true,
      component: Animal,
    },
    {
      name: 'activity',
      path: '/activity',
      component: Activity,
    },
    {
      name: 'slideshow',
      path: '/slideshow',
      component: Slideshow,
    },
  ],
});

router.beforeEach((from, to, next) => {
  window.scrollTo(0, 0);

  next();
});

export default router;